import {useId} from 'react'

type Props = React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
  label?: string
  error?: string
}

const Textarea = (props: Props) => {
  const {label, autoComplete, error, className, required, style, ...rest} = props
  const id = useId()

  return (
    <div className='w-100'>
      {label && (
        <label className={`form-label fw-semibold text-dark fs-6 ${required && 'required'}`}>
          {label}
        </label>
      )}

      <textarea
        rows={5}
        id={id}
        className={`form-control ${error ? 'is-invalid' : ''}`}
        style={{
          ...style,
        }}
        {...rest}
      />

      {error && (
        <div className='fv-plugins-message-container'>
          <div className='fv-help-block'>
            <span role='alert'>{error}</span>
          </div>
        </div>
      )}
    </div>
  )
}

export default Textarea
